<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
    <div class="logo">CPD<span>sys</span></div>
</template>